import React from 'react';
import { IconProps } from '.';

const SvgBoxReturn = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <g fill={color} clipPath='url(#BoxReturn_svg__a)'>
        <path
          fillRule='evenodd'
          d='M22.75 2.25H1.25v5.5h1v14H14v-1.5H3.75V7.75h16.5V13h1.5V7.75h1v-5.5Zm-1.5 4H2.75v-2.5h18.5v2.5Z'
          clipRule='evenodd'
        />
        <path d='M20.011 19.049 18.99 17.95l-3.05 2.841 3.013 3.22 1.096-1.024-1.158-1.238H20a3.75 3.75 0 1 0 0-7.5h-3v1.5h3a2.25 2.25 0 0 1 0 4.5h-1.279l1.29-1.201Z' />
      </g>
      <defs>
        <clipPath id='BoxReturn_svg__a'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgBoxReturn;
